const locations = [
  "Lengnau",
  "Würenlos",
  "Travers",
  "Rapperswil",
  "Erstfeld",
  "Payerne",
  "Vevey",
  "Magadino-Vira",
  "Hindelbank",
  "Arth-Goldau",
  "Bussigny",
  "Reiden",
  "Dachsen",
  "Niederglatt",
  "Bonstetten-Wettswil",
  "Villeneuve",
  "Zürich Tiefenbrunnen",
  "Sonceboz-Sombeval",
  "Opfikon",
  "Amriswil",
  "Suberg-Grossaffoltern",
  "Dinhard",
  "Kaltbrunn",
  "Aarberg",
  "Lenzburg",
  "Eclépens",
  "Uerikon",
  "Olten Hammer",
  "Hitzkirch",
  "Steg",
  "Murgenthal",
  "Horgen",
  "Auvernier",
  "Räterschen",
  "Biasca",
  "Dübendorf",
  "Urdorf",
  "Grenchen Süd",
  "Tecknau",
  "Raron",
  "Zwingen",
  "Sempach-Neuenkirch",
  "Cossonay-Penthalaz",
  "St. Gallen St. Fiden",
  "Leuk",
  "Gossau SG",
  "Flawil",
  "Gland",
  "Rafz",
  "Märstetten",
  "Wangen an der Aare",
  "Grandson",
  "Wichtrach",
  "Au ZH",
  "Elgg",
  "Herzogenbuchsee",
  "Lamone-Cadempino",
  "Neuchâtel-Serrières",
  "Grolley",
  "Glovelier",
  "Näfels-Mollis",
  "Turbenthal",
  "Stammheim",
  "Balerna",
  "Niederweningen Dorf",
  "Sissach",
  "Mosen",
  "Boswil-Bünzen",
  "Kollbrunn",
  "Aigle",
  "Wolhusen",
  "Heerbrugg",
  "Ziegelbrücke",
  "Langnau",
  "Wald",
  "Aathal",
  "Hinwil",
  "Corcelles-Sud",
  "Rotkreuz",
  "Steinen",
  "Lucens",
  "Taverne-Torricella",
  "Mezzovico",
  "Sirnach",
  "Eiken",
  "Thalheim-Altikon",
  "Feldbach",
  "Richterswil",
  "Courtelary",
  "Pfungen",
  "Riazzino",
  "Ostermundigen",
  "Niederweningen",
  "Rickenbach-Attikon",
  "Gelterkinden",
  "Siebnen-Wangen",
  "Effretikon",
  "Pratteln",
  "Corcelles-Peseux",
  "Buchs-Dällikon",
  "Flamatt",
  "Wildegg",
  "Henggart",
  "Rubigen",
  "Zollikofen",
  "Buchs SG",
  "Tannay",
  "Uzwil",
  "Bodio",
  "Airolo",
  "Möhlin",
  "Bauma",
  "Ranzo-S. Abbondio",
  "Knonau",
  "Killwangen-Spreitenbach",
  "Giubiasco",
  "Dornach-Arlesheim",
  "Beinwil am See",
  "Bettlach",
  "Düdingen",
  "Rothenburg Dorf",
  "Neyruz",
  "Niederhasli",
  "Oensingen",
  "Vallorbe",
  "Winterthur Seen",
  "Koblenz",
  "Glattfelden",
  "Baden",
  "Murten",
  "Herrliberg-Feldmeilen",
  "Flums",
  "Grandvaux",
  "Tenero",
  "Melide",
  "Lutry",
  "Gisikon-Root",
  "Bülach",
  "Mendrisio",
  "Oberriet",
  "Winterthur Wülflingen",
  "Porrentruy",
  "Aadorf",
  "Grellingen",
  "Wettingen",
  "Embrach-Rorbas",
  "St-Imier",
  "Küsnacht ZH",
  "Dagmersellen",
  "Reichenburg",
  "Boudry",
  "Kloten",
  "Arbon",
  "Solothurn",
  "Ballwil",
  "Wünnewil",
  "Altdorf",
  "Rupperswil",
  "Croy-Romainmôtier",
  "Dietlikon",
  "Solothurn West",
  "Avenches",
  "Emmenbrücke",
  "Muttenz",
  "Uttigen",
  "Pfäffikon SZ",
  "Lausen",
  "Ossingen",
  "Rivera-Bironico",
  "Hägendorf",
  "Schmerikon",
  "Schöfflisdorf-Oberweningen",
  "Uetikon",
  "Fehraltorf",
  "Gampel-Steg",
  "Döttingen",
  "Schwanden",
  "Mettmenstetten",
  "Courgenay",
  "Sion",
  "Steinmaur",
  "Nottwil",
  "Maienfeld",
  "Rothenburg",
  "Zug Schutzengel",
  "Allaman",
  "Granges-Marnand",
  "Puidoux",
  "Satigny",
  "Frenkendorf-Füllinsdorf",
  "Glarus",
  "Göschenen",
  "Escholzmatt",
  "Cousset",
  "Waldibrücke",
  "Wallisellen",
  "Au SG",
  "Zug",
  "Schüpfen",
  "Arnegg",
  "Hettlingen",
  "Lugano",
  "Altendorf",
  "Faido",
  "Winterthur Grüze",
  "Maroggia-Melano",
  "Küssnacht am Rigi",
  "Chur",
  "Marthalen",
  "Uznach",
  "Delémont",
  "Hochdorf",
  "Rümlang",
  "Brunnen",
  "Bilten",
  "Sulgen",
  "Kerzers",
  "Moutier",
  "Schmitten",
  "Münchenbuchsee",
  "Cadenazzo",
  "Aarburg-Oftringen",
  "Wiesendangen",
  "Turgi",
  "Stein-Säckingen",
  "St. Gallen",
  "Laufen",
  "Arnex",
  "Baar",
  "Liestal",
  "Gordola",
  "Rorschach",
  "Sargans",
  "Coppet",
  "Lachen",
  "Weinfelden",
  "Bad Ragaz",
  "Ebikon",
  "Nebikon",
  "Busswil",
  "Romanshorn",
  "Glattbrugg",
  "Chiasso",
  "Kempten",
  "Laufenburg",
  "Dielsdorf",
  "Wil",
  "Cham",
  "Belfaux CFF",
  "Ecublens-Rue",
  "Benzenschwil",
  "Goldach",
  "Burgdorf",
  "Egnach",
  "Hauptwil",
  "Oberentfelden",
  "Oberrieden Dorf",
  "Bütschwil",
  "Castione-Arbedo",
  "Salez-Sennwald",
  "Brig",
  "Monthey",
  "Kradolf",
  "Wila",
  "Eschlikon",
  "St-Maurice",
  "Egerkingen",
  "Schüpfheim",
  "Nieder- und Oberurnen",
  "Bellinzona",
  "Rebstein-Marbach",
  "Rheineck",
  "Münsingen",
  "Walenstadt",
  "S. Antonino",
  "Chavornay",
  "Thalwil",
  "Courtételle",
  "Münchenstein",
  "Schübelbach-Buttikon",
  "Sevelen",
  "Otelfingen",
  "Birrwil",
  "Gümligen",
  "Trubschachen",
  "Meilen",
  "Oberrüti",
  "Moudon",
  "Vernayaz",
  "Brugg AG",
  "Bad Zurzach",
  "Wangen bei Olten",
  "Rüschlikon",
  "Illnau",
  "Nänikon-Greifensee",
  "Mumpf",
  "Bex",
  "Pieterlen",
  "Däniken",
]

export default locations